// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ZPov7","inner":"Footer_inner__rUvG7"};